import axios from 'axios'

// 小于等于0取0
export function getTagList(url, success, error) {
  axios
  .post(url + "/api/getTagLists", {})
  .then(success)
  .catch(error);
}



// WEBPACK FOOTER //
// ./src/utils/request.js